import dndPromotion from "../../setup/js/_promotion.js";
$(document).on("metaslug_sinhnhat1tuoi_vongquay rendered", {}, function (event, uniqueId) {
  var $this = $("#" + uniqueId);
  dndPromotion({
    url: domain,
    debug: {
      status: false,
      testReward: "0",
    },
    //directory: "https://global-mainsite.mto.zing.vn/products/metalslug/landing/2024-sinh-nhat-1-tuoi/prod/metaslug_sinhnhat1tuoi/required_popup/images/qua-en/",
    items: {
      A: "1",
      B: "2",
      C: "3",
      D: "4",
      E: "5",
      F: "6",
      G: "7",
      H: "8",
      I: "9",
      
      length: 9,
      type: "png",
    },
    names: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
    config: {
      classImg: ".animation_circle",
      timeWait: 2000,
      animationCircle: true,
    },
  });



});